// extracted by mini-css-extract-plugin
module.exports = {"Followed":"Followed_Followed__3Ok-M","Follow":"Followed_Follow__3miTi","link":"Followed_link__u9EGt","footer":"Followed_footer__2FTOQ"};